var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCetLogoHe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.333,
    height: 24.009,
    viewBox: "0 0 78.333 24.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CET_logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M36.4,35.647h1.076V33.632H36.4Zm3.554,0H38.877v-2.1a.935.935,0,0,0-.159-.654.961.961,0,0,0-.629-.148H36.4V32.02h2.168a1.443,1.443,0,0,1,1.062.332,1.586,1.586,0,0,1,.324,1.127Z",
    transform: "translate(-13.394 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M108.6,35.647h1.076V33.632H108.6Zm3.554,0h-1.077v-2.1a.935.935,0,0,0-.159-.654.961.961,0,0,0-.629-.148H108.6V32.02h2.167a1.439,1.439,0,0,1,1.062.332,1.58,1.58,0,0,1,.326,1.127Z",
    transform: "translate(-39.961 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M105.724,33.766a3.122,3.122,0,0,1-.2,1.221,1.068,1.068,0,0,1-1.055.693,2.048,2.048,0,0,1-.3-.021,2.511,2.511,0,0,1-.343-.08v-.708a.386.386,0,0,0,.072.028.533.533,0,0,0,.18.037.428.428,0,0,0,.376-.21,1.779,1.779,0,0,0,.2-.961,2.6,2.6,0,0,0-.108-.918.53.53,0,0,0-.535-.3.781.781,0,0,0-.765.47,2,2,0,0,0-.152.853V35.58h-1.07V33.022c0-.221-.009-.455-.028-.7s-.039-.368-.058-.368h.9c.034,0,.07.075.109.224a1.611,1.611,0,0,1,.058.4l.044.015a1.458,1.458,0,0,1,.455-.506,1.509,1.509,0,0,1,1.973.282,2.909,2.909,0,0,1,.245,1.4",
    transform: "translate(-37.512 -11.716)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M99.4,35.647H98.249V33.573a1.133,1.133,0,0,0-.13-.621.646.646,0,0,0-.564-.224H96.3V32.02h1.632a1.825,1.825,0,0,1,1.156.268,1.243,1.243,0,0,1,.311.975Z",
    transform: "translate(-35.436 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M92.4,35.647H91.045v-.715h1.2a.9.9,0,0,0,.743-.339A1.278,1.278,0,0,0,93,33.074a.917.917,0,0,0-.751-.346h-1.2V32.02H92.4a1.939,1.939,0,0,1,1.466.564,1.845,1.845,0,0,1,.008,2.5,1.947,1.947,0,0,1-1.474.564",
    transform: "translate(-33.503 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    d: "M88.855,32.735c-.3,0-.485.035-.545.106a1.2,1.2,0,0,0-.091.619v2.187H87.143V33.5a1.012,1.012,0,0,1,.08-.455.644.644,0,0,1,.47-.3.535.535,0,0,0-.138-.008H86.544V32.02h2.311Z",
    transform: "translate(-31.847 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M80.973,31.807l-.491,2.919H79.413l.419-2.218c.02-.082.033-.153.044-.214a1.091,1.091,0,0,0,.014-.169.307.307,0,0,0-.09-.231.448.448,0,0,0-.314-.087h-.817a.93.93,0,0,1-.542-.137.646.646,0,0,1-.246-.569v-.872a2.8,2.8,0,0,0-.057-.6.641.641,0,0,0-.037-.116h1.04a.4.4,0,0,1,.029.094,2.016,2.016,0,0,1,.079.561,2.974,2.974,0,0,0,.058.813q.058.115.405.114h.909a.642.642,0,0,1,.506.2.618.618,0,0,1,.159.513",
    transform: "translate(-28.624 -10.862)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M75.716,33.863a1.9,1.9,0,0,1-.484,1.462,1.959,1.959,0,0,1-1.344.391,2.094,2.094,0,0,1-1.546-.5,1.277,1.277,0,0,1-.361-.932V31.944h1.076v2.067a1.126,1.126,0,0,0,.166.665.757.757,0,0,0,.664.3.655.655,0,0,0,.672-.362,2.15,2.15,0,0,0,.087-.746,3.084,3.084,0,0,0-.08-.834.549.549,0,0,0-.556-.442.756.756,0,0,0-.275.051.483.483,0,0,0-.1.051v-.665a1.209,1.209,0,0,1,.357-.166,1.668,1.668,0,0,1,.409-.044,1.106,1.106,0,0,1,.989.489,2.881,2.881,0,0,1,.325,1.56",
    transform: "translate(-26.488 -11.707)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M67.425,35.647H66.075v-.715h1.2a.9.9,0,0,0,.743-.339,1.278,1.278,0,0,0,.008-1.517.917.917,0,0,0-.751-.346h-1.2V32.02h1.351a1.941,1.941,0,0,1,1.467.564,1.844,1.844,0,0,1,.007,2.5,1.947,1.947,0,0,1-1.474.564",
    transform: "translate(-24.314 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    d: "M63.941,35.647H61.68v-.715h1.185V33.559a1.305,1.305,0,0,0-.1-.628.592.592,0,0,0-.535-.2h-.5V32.02h1.012a1.233,1.233,0,0,1,.845.268,1.183,1.183,0,0,1,.354.939Z",
    transform: "translate(-22.697 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M59.993,35.647H58.917V32.728a2.4,2.4,0,0,0-.065-.607.371.371,0,0,0-.036-.1h1.04c.029.087.051.159.065.217a2.131,2.131,0,0,1,.072.506Z",
    transform: "translate(-21.643 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M56.166,31.807l-.491,2.919H54.6l.419-2.218c.02-.082.034-.153.044-.214a1.1,1.1,0,0,0,.015-.169.307.307,0,0,0-.09-.231.448.448,0,0,0-.314-.087h-.816a.927.927,0,0,1-.542-.137.645.645,0,0,1-.246-.569v-.872a2.8,2.8,0,0,0-.058-.6.594.594,0,0,0-.037-.116h1.04a.373.373,0,0,1,.029.094,1.994,1.994,0,0,1,.08.561,2.987,2.987,0,0,0,.058.813c.039.076.174.114.405.114h.91a.64.64,0,0,1,.506.2.619.619,0,0,1,.159.513",
    transform: "translate(-19.495 -10.862)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M51.7,35.647H50.627V32.728a2.4,2.4,0,0,0-.065-.607.367.367,0,0,0-.035-.1h1.04c.029.087.051.159.065.217a2.136,2.136,0,0,1,.073.506Z",
    transform: "translate(-18.593 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    d: "M48.149,35.647h-.983a.455.455,0,0,1-.123-.235,1.966,1.966,0,0,1-.021-.314c0-.1-.013-.152-.037-.152q-.007,0-.188.4a.641.641,0,0,1-.636.4,1.464,1.464,0,0,1-.47-.051.138.138,0,0,1-.072-.058V34.83a.989.989,0,0,0,.453.116.749.749,0,0,0,.617-.318,1.467,1.467,0,0,0,.245-.91q0-.708-.183-.842a2.323,2.323,0,0,0-1.045-.133V32.02h.865a1.465,1.465,0,0,1,1.131.351,2,2,0,0,1,.309,1.289v1.12a3.613,3.613,0,0,0,.032.47,1.348,1.348,0,0,0,.1.4",
    transform: "translate(-16.787 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M44.165,34.122H43.073V32.728a1.506,1.506,0,0,0-.051-.4,1.245,1.245,0,0,0-.123-.311h1.084a.87.87,0,0,1,.115.253,1.591,1.591,0,0,1,.066.455Z",
    transform: "translate(-15.786 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    d: "M29.463,35.647H28.386V33.554a1.241,1.241,0,0,0-.116-.674c-.077-.1-.253-.145-.527-.145h-.853v2.912H25.815V32.02h2.4a1.286,1.286,0,0,1,1.012.334,1.306,1.306,0,0,1,.238.868Z",
    transform: "translate(-9.499 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    d: "M24.3,34.122H23.2V32.728a1.506,1.506,0,0,0-.051-.4,1.245,1.245,0,0,0-.123-.311h1.084a.891.891,0,0,1,.116.253,1.613,1.613,0,0,1,.065.455Z",
    transform: "translate(-8.475 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    d: "M21.236,35.647H18.975v-.715H20.16V33.559a1.313,1.313,0,0,0-.1-.628.592.592,0,0,0-.535-.2h-.5V32.02h1.012a1.23,1.23,0,0,1,.844.268,1.181,1.181,0,0,1,.355.939Z",
    transform: "translate(-6.982 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-20",
    d: "M17.242,35.647H16.166V32.728a2.4,2.4,0,0,0-.065-.607.371.371,0,0,0-.036-.1H17.1c.029.087.051.159.065.217a2.131,2.131,0,0,1,.072.506Z",
    transform: "translate(-5.911 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    d: "M11.559,35.647H10.208v-.715h1.2a.9.9,0,0,0,.744-.339,1.278,1.278,0,0,0,.008-1.517.919.919,0,0,0-.751-.346h-1.2V32.02h1.351a1.939,1.939,0,0,1,1.466.564,1.845,1.845,0,0,1,.008,2.5,1.947,1.947,0,0,1-1.474.564",
    transform: "translate(-3.756 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    d: "M8.67,34.122H7.578V32.728a1.533,1.533,0,0,0-.05-.4,1.244,1.244,0,0,0-.123-.311H8.489a.891.891,0,0,1,.116.253,1.613,1.613,0,0,1,.065.455Z",
    transform: "translate(-2.725 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    d: "M4.27,35.647H3.193V33.566a1.2,1.2,0,0,0-.123-.672c-.082-.1-.277-.152-.585-.152h-.81v1.727A2.041,2.041,0,0,1,1.5,35.506q-.173.249-.774.249A2.138,2.138,0,0,1,.151,35.7c-.1-.033-.152-.077-.152-.13v-.722a.662.662,0,0,0,.1.058.524.524,0,0,0,.224.065.238.238,0,0,0,.195-.1.622.622,0,0,0,.08-.365V32.02H2.832A1.65,1.65,0,0,1,4,32.309a1.818,1.818,0,0,1,.267,1.177Z",
    transform: "translate(0 -11.783)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    d: "M75.863.711A2.266,2.266,0,0,1,77.436,0H95.485s2.168-.034,2.388,2.986a2.55,2.55,0,0,1,2.4-1.26H104s2.888-.18,1.819,2.512l-4.949,12.176a2.5,2.5,0,0,1-2.143,1.316H86.91a1.434,1.434,0,0,1-1.408-1.1,2.941,2.941,0,0,1-1.776,1.1c-.1,0-3.987.006-5.016-.006-.8.006-1.284-.346-1.476-1.494,0,0-1.849-14.354-1.882-14.4a.2.2,0,0,0,0,.026c0-.018,0-.027,0-.026a1.533,1.533,0,0,1,.51-1.119m20.06,2.214H85.754A2.924,2.924,0,0,0,83.317,4.66L79.063,14.818c-.4.958.04,1.734.986,1.734H82.78a2.925,2.925,0,0,0,2.438-1.734L89.424,4.795a1.136,1.136,0,0,1,.925-.693c.351,0,.5.31.344.693L86.5,14.818c-.4.958.04,1.734.985,1.734H97.574a2.393,2.393,0,0,0,2.438-1.734L104.265,4.66c.4-.958.469-1.735-.985-1.734h-2.732A2.925,2.925,0,0,0,98.11,4.66l-4.2,10.028a1.115,1.115,0,0,1-.891.693c-.332,0-.471-.31-.311-.693L96.932,4.6c.36-.931-.082-1.677-1.009-1.677",
    transform: "translate(-27.728 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    d: "M39.716,12.073A7.992,7.992,0,0,1,37.8,17.709a7.365,7.365,0,0,1-5.689,2.158,8.025,8.025,0,0,1-5.151-1.511,5.7,5.7,0,0,1-2.076-4.746V6.842a1.643,1.643,0,0,1,.7-1.4,2.714,2.714,0,0,1,3.02,0,1.644,1.644,0,0,1,.7,1.4v6.93q0,3.155,2.912,3.155a2.488,2.488,0,0,0,2.319-1.618,7.366,7.366,0,0,0,.593-3.128q0-4.1-1.483-4.1-.351,0-.971.863t-1.159.863A1.067,1.067,0,0,1,30.6,9.3a1.7,1.7,0,0,1-.27-.916,3.884,3.884,0,0,1,.459-1.645q.863-1.753,3.505-1.753a4.7,4.7,0,0,1,4.288,2.347,9.1,9.1,0,0,1,1.133,4.746",
    transform: "translate(-9.157 -1.833)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    d: "M14.559,17.951a1.639,1.639,0,0,1-.7,1.4,2.4,2.4,0,0,1-1.51.458,2.4,2.4,0,0,1-1.511-.457,1.641,1.641,0,0,1-.7-1.4v-6.7q0-2.744-2.938-2.744H5.257v9.442a1.641,1.641,0,0,1-.7,1.4,2.4,2.4,0,0,1-1.51.457,2.4,2.4,0,0,1-1.51-.458,1.64,1.64,0,0,1-.7-1.4V7.185q0-1.777,1.968-1.777H8.438a6.668,6.668,0,0,1,4.315,1.346,4.834,4.834,0,0,1,1.806,3.984Z",
    transform: "translate(-0.307 -1.99)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    d: "M65.43,12.235a8.83,8.83,0,0,1-1.294,4.989A5.236,5.236,0,0,1,59.47,19.57H58.23q-1.348,0-1.348-1.537,0-1.564,1.348-1.564h.432A1.911,1.911,0,0,0,60.576,14.9a9.384,9.384,0,0,0,.3-2.723q0-4.126-2.885-4.126T55.1,12.2v5.6a1.641,1.641,0,0,1-.7,1.4,2.722,2.722,0,0,1-3.02,0,1.64,1.64,0,0,1-.7-1.4V6.838a1.639,1.639,0,0,1,.7-1.4,2.4,2.4,0,0,1,1.51-.458,1.832,1.832,0,0,1,2,1.43q.082.3.189.3c.072,0,.179-.071.324-.216a5.111,5.111,0,0,1,3.856-1.511,5.535,5.535,0,0,1,4.827,2.185,8.481,8.481,0,0,1,1.348,5.069",
    transform: "translate(-18.649 -1.833)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCetLogoHe);
export default __webpack_public_path__ + "static/media/CET_logo_he.1f1a48d74e9e9fcc72f121e3c2aa14bb.svg";
export { ForwardRef as ReactComponent };